var epicaAnchors = document.querySelectorAll('[data-epica-module-name] a[href]');

var epicaClick = function (e) {
    if (e.currentTarget.href.indexOf('#') === -1 && e.currentTarget.href.indexOf('void(0)') === -1) {
        var moduleName = e.currentTarget.closest('[data-epica-module-name]').getAttribute('data-epica-module-name');
        dataLayer.push({
            'event': 'epicaClick',
            'epicaClickData': {
                x: e.pageX,
                y: e.pageY,
                moduleName: moduleName,
                href: e.currentTarget.href,
                referer: document.location.href,
                origin: "La República"
            },
            'gaClickData': {
                hitType: 'event',
                eventAction: 'click',
                eventCategory: moduleName,
                eventLabel: document.location.href,
                transport: 'beacon'
            }
        });
    }
};

epicaAnchors.forEach(function (el) {
    el.addEventListener('click', epicaClick);
});